import { createAction, props } from '@ngrx/store';
import { VonPageResponseModel } from '@von-development-studio/angular-rest-service';
import { SelectItem } from 'primeng/api';
import { CommonDoctorModel } from 'src/app/model/common/doctor';
import { CommonDoctorViewModel } from 'src/app/model/common/doctor.view';
import { KhuyanaSelectItemModel } from 'src/app/model/core/khuyana-select-item.model';

enum CommonDoctorLabels {
  SET_RESULT = 'COMMON_DOCTOR_SET_RESULT',
  ADD_RESULT = 'COMMON_DOCTOR_ADD_RESULT',
  PATCH_RESULT = 'COMMON_DOCTOR_UPDATE_RESULT',
  SET_DOCTOR = 'COMMON_DOCTOR_SET_DOCTOR',
  SET_RESIDENCE = 'COMMON_DOCTOR_SET_RESIDENCE',
  SET_DOCTOR_DEFAULT = 'COMMON_DOCTOR_SET_DOCTOR_DEFAULT',
  SET_ALL_DEFAULT = 'COMMON_DOCTOR_SET_ALL_DEFAULT',
}

export const commonDoctorActions = {
  setResultAction: createAction(
    CommonDoctorLabels.SET_RESULT,
    props<VonPageResponseModel<CommonDoctorViewModel>>()
  ),
  addResultAction: createAction(
    CommonDoctorLabels.ADD_RESULT,
    props<CommonDoctorViewModel>()
  ),
  patchResultAction: createAction(
    CommonDoctorLabels.PATCH_RESULT,
    props<CommonDoctorViewModel>()
  ),
  setDoctorAction: createAction(
    CommonDoctorLabels.SET_DOCTOR,
    props<CommonDoctorModel>()
  ),
  setResidenceAction: createAction(
    CommonDoctorLabels.SET_RESIDENCE,
    props<SelectItem<KhuyanaSelectItemModel>>()
  ),
  setDoctorDefaultAction: createAction(
    CommonDoctorLabels.SET_DOCTOR_DEFAULT,
    props<any>()
  ),
  setAllDefaultAction: createAction(CommonDoctorLabels.SET_ALL_DEFAULT, props<any>()),
};
